<template>
    <div class="white-box white-box-no-tab">
        <TermsFrame
            title="保險單借款"
            btnText="本人已閱讀並暸解"
            needLayer
            needGuideArrow
            :needBtn="isScrollToBottom"
            :content="content"
            :isLoading="isLoading"
            @isScrollToBottom="v => isScrollToBottom = v"
            @clickBtn="goNext"
        >
            <template #subtitle>
                <div class="text-error mb-2.5 font-bold">
                    借款人如以其所申請借款之金額再行購買保險公司其他商品之權益說明
                </div>
            </template>
        </TermsFrame>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsOtherCommodityPon4300, postAgreeOtherCommodityPon4300 } from '@/apis/Pon4300.js';
import routeName from '@/router/constant.js';
import TermsFrame from '@/components/template/TermsFrame.vue';

export default {
    components: {
        // TermsBox,
        TermsFrame
    },
    setup() {
        const router = useRouter();
        const content = ref('');
        const isLoading = ref(false);
        const isScrollToBottom = ref(false);
        const getTerms = () => {
            getAgreeTermsOtherCommodityPon4300().then(res => {
                if (res.data.agreeTerms) content.value = res.data.agreeTerms.content;
            });
        };
        getTerms();

        const goNext = () => {
            isLoading.value = true;
            postAgreeOtherCommodityPon4300().then(res => {
                router.push({ name: routeName.EDIT_TEL_MAIL });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return { goNext, content, isLoading, isScrollToBottom };
    },
};
</script>
